import AppDispatcher from '../AppDispatcher';
import Remote from '../Remote';

const QuoteFeedStore = {

  _feeds: [],

  getAll: function () {
    return this._feeds;
  },

  getForSelect: function () {
    let options = [];

    for (let i = 0; i < this._feeds.length; i++) {
      options.push({
        value: this._feeds[i].Id,
        label: this._feeds[i].Name
      });
    }
    return options;
  },

  getMap: function () {
    let options = {};

    for (let i = 0; i < this._feeds.length; i++) {
      options[this._feeds[i].Id] = this._feeds[i].Name;
    }
    return options;
  },

  get: function (id) {
    for (let i = 0; i < this._feeds.length; i++) {
      if (this._feeds[i].Id === id) {
        return this._feeds[i];
      }
    }
    return null;
  },

  emitChange: function () {
    this.trigger(Constants.ActionTypes.QUOTE_FEED.UPDATE);
  },

  /**
   * @param {function} callback
   */
  addChangeListener: function (callback) {
    this.bind(Constants.ActionTypes.QUOTE_FEED.UPDATE, callback);
  },

  removeChangeListener: function (callback) {
    this.unbind(Constants.ActionTypes.QUOTE_FEED.UPDATE, callback);
  },

  handleDispatcher: function (action) {
    switch (action.actionType) {
      case Constants.ActionTypes.QUOTE_FEED.UPDATE:
        Remote.quoteFeedsGet(response => {
          this._feeds = response.Result.Feeds;
          this.emitChange();
        });
        break;
      case Constants.ActionTypes.QUOTE_FEED.SET:
        this._feeds = action.items;
        this.emitChange();
        break;
    }
  }
};

MicroEvent.mixin(QuoteFeedStore);

AppDispatcher.register(QuoteFeedStore.handleDispatcher.bind(QuoteFeedStore));

export default QuoteFeedStore;



// WEBPACK FOOTER //
// ./src/js/Stores/QuoteFeedStore.js